import { message } from "antd";
import React, { useEffect, useState } from "react";
import apis from "../../../services/apiCrypto";
import IntegrationButton from "../IntegrationButton";
import { IntegrationStatus } from "../CryptoIntegration";
// import { useSideBar } from "../../../contexts/SideBarContext";
// import bitcoinTradeLogo from "../../../assets/bitcointrade-logo.svg";
import BitcoinTradeIntegrationModal from "./BitcoinTradeIntegrationModal";
// import bitcoinTradeLogoWhite from "../../../assets/bitcointrade-logo-white.svg";

interface IGetEstadoIntegracao {
  success: (data: any) => void;
  error: (data: any) => void;
}

interface IBitcoinTradeIntegrationProps {
  dependentId?: string;
  integrationCallback: (type: IntegrationStatus) => void;
}

const BitcoinTradeIntegration: React.FC<IBitcoinTradeIntegrationProps> = ({
  integrationCallback,
}) => {
  // const { dark } = useSideBar();
  const [loading, setLoading] = useState(true);
  const [integrationModalVisible, setIntegrationModalVisible] = useState(false);
  const [integrado, setIntegrado] = useState(false);
  const [integrationData, setIntegrationData] = useState();

  const getEstadoIntegracao = ({ success, error }: IGetEstadoIntegracao) =>
    apis
      .get("/bitcoin-trade/integration-status")
      .then((res) => {
        setIntegrationData(res.data);
        success(res.data);
      })
      .catch((err) => {
        error(err);
      });

  const setIntegrationLoadingSequence = (
    loading: boolean,
    integrate: boolean,
    status: IntegrationStatus
  ) => {
    setLoading(loading);
    setIntegrado(integrate);
    integrationCallback(status);
  };

  useEffect(() => {
    getEstadoIntegracao({
      success: (data) => {
        if (data.status) {
          if (data?.status === "carregando") {
            setIntegrationLoadingSequence(true, false, "carregando");
          } else if (data?.status === "sucesso") {
            setIntegrationLoadingSequence(false, true, "integrado");
          } else if (data?.status === "erro") {
            integrationCallback("erro");
          }
        } else {
          if (!data.integrated && data.providerExists) {
            setIntegrationLoadingSequence(true, false, "carregando");
          } else if (data.integrated) {
            setIntegrationLoadingSequence(false, true, "integrado");
          }
        }
      },
      error: () => integrationCallback("erro"),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;
    if (loading) {
      interval = setInterval(
        () => {
          integrationCallback("carregando");
          getEstadoIntegracao({
            success: (data: any) => {
              if (data?.status === "carregando" && data.providerExists) {
                integrationCallback("carregando");
              }

              // Se estiver carregando e venceu o timeout libera
              if (
                data?.status === "carregando" &&
                (data?.statusTimestamp || new Date().getTime()) <
                  new Date().getTime() - 1000 * 60 * 5
              ) {
                setLoading(false);
                setIntegrado(false);
              }

              if (!data.providerExists || data?.status === "erro") {
                setLoading(false);
                setIntegrado(false);
              }

              if (data.status === "sucesso") {
                setLoading(false);
                setIntegrado(true);
                message.success("Integração feita com sucesso!");
                integrationCallback("integrado");
              }
            },
            error: (err: any) => {
              setLoading(false);
              integrationCallback("erro");
              if (err.response?.data?.message) {
                return message.error(err.response?.data?.message);
              }
              return message.error(
                "Algo deu errado na integração com a Bitcoin Trade, verifique suas credenciais"
              );
            },
          });
        },

        3000
      );
    } else {
      if (interval) {
        clearInterval(interval);
      }
    }
    return () => clearInterval(interval as unknown as NodeJS.Timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, integrado]);

  return (
    <>
      <IntegrationButton
        imgHeight
        loading={loading}
        integrado={integrado}
        alt="Integrar com a BitcoinTrade"
        logo="https://conteudos.xpi.com.br/wp-content/uploads/2022/06/xtage.jpg?quality=75&strip=all&w=280&h=280"
        setIntegrationModalVisible={setIntegrationModalVisible}
      />
      <BitcoinTradeIntegrationModal
        visible={integrationModalVisible}
        setVisible={setIntegrationModalVisible}
        setLoadingIntegration={setLoading}
        integrationData={integrationData}
      />
    </>
  );
};

export default BitcoinTradeIntegration;
